<script>
import Timer from './timer'
// import REPLAY_DATA from './replayData'
import { getRecords } from 'api/index'
import { parseTime, getUrlParam } from 'common/js/common'
import { MessageBox } from 'bxs-ui-vue'
import audioLoader from 'audio-loader'
export default {
  name: 'ReplayToolbelt',
  components: {
    [MessageBox.name]: MessageBox,
  },
  props: {
    tim: {
      type: Object,
      default() {
        return {}
      },
    },
    replayLoading: {
      type: Boolean,
      default: false,
    },
    isBoardShow: {
      type: Boolean,
      default: false,
    },
    isForPresentation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      audioSrc: '',
      currentTime: 0, // 当前时间
      duration: 0,
      precent: 0,
      disabled: true,
      playing: false,
      fetchLoading: false,
    }
  },
  computed: {
    loading() {
      const { replayLoading, fetchLoading, playerService } = this
      //  || duration <= 0
      return replayLoading || fetchLoading || !playerService
    },
    durationTimeStamp() {
      return this.format(this.duration)
    },
    currentTimeStamp() {
      return this.format(this.currentTime)
    },
    excessTimeStamp() {
      return this.format(this.duration - this.currentTime)
    },
    nowPlaying() {
      return this.duration - this.currentTime > 0 && !this.isBoardShow
    },
  },
  watch: {
    loading(value) {
      if (window.appBridge) {
        appBridge[value ? 'showLoading' : 'hideLoading']()
      }
    },
  },
  created() {
    this.pageState = {
      pageSize: 20,
      pageNum: 0,
    }
    this.recordUuid = getUrlParam('replay')
    this.fetchData()
  },
  mounted() {
    this.audio = this.createAudio()
  },
  methods: {
    fetchData() {
      const { recordUuid } = this
      const { pageSize, pageNum } = this.pageState
      this.fetchLoading = true
      getRecords({ recordUuid, pageSize, pageNum }).then(
        ({ success, data, info } = {}) => {
          if (!success || !data) {
            this.$messagebox({
              message: info || '接口异常',
              className: 'replay-error',
              cancelButtonText: '知道了',
              showConfirm: false,
            })
            return
          }
          if (!data.msgPage || !data.msgPage.content.length || !data.audioUrl) {
            this.$messagebox({
              message: info || '数据获取异常',
              className: 'replay-error',
              cancelButtonText: '知道了',
              showConfirm: false,
            })
            return
          }
          // REPLAY_DATA
          const actions = this.createAction(
            data.msgPage.content,
            this.baselineTime
          )
          if (!pageNum) {
            this.baselineTime = data.msgPage.content[0].timestamp
            this.audioSrc = data.audioUrl
            this.playerService = this.createPlayerService(actions, 1)
            audioLoader(data.audioUrl).then((buffer) => {
              this.duration = buffer.duration
            })
          } else {
            this.playerService.addActions(actions)
          }
          if (data.msgPage.last) {
            this.fetchLoading = false
          } else {
            this.pageState.pageNum++
            this.fetchData()
          }
        }
      )
    },
    createAudio() {
      const audio = this.$refs.audio
      audio.addEventListener('loadedmetadata', () => {
        console.log('loadedmetadata', audio.duration)
        this.duration = audio.duration
      })
      audio.addEventListener('timeupdate', () => {
        // console.log('timeupdate', audio.currentTime)
        if (!this.isTouchMove) {
          this.currentPrecent(audio.currentTime)
        }
        this.currentTime = audio.currentTime
        this.$emit('timeupdate', audio.currentTime)
        // this.update(audio.currentTime * 1000)
      })
      audio.addEventListener('play', () => {
        console.log('play')
        if (!this.played) {
          this.played = true
        }
        this.playing = true
      })
      audio.addEventListener('pause', () => {
        console.log('pause')
        this.playing = false
      })
      // // 因为缺少数据而暂停或延迟的状态结束，播放准备开始
      audio.addEventListener('playing', () => {
        console.log('playing', audio.currentTime)
        console.log('played', this.played)
        // this.playerService.play(audio.currentTime * 1000)
        // this.played && this.toolbelt.toggleTimer(true)
      })
      // // 因为暂时性缺少数据，播放暂停
      audio.addEventListener('waiting', () => {
        console.log('waiting', audio.currentTime)
        //   this.playerService.stop()
        //   this.played && this.toolbelt.toggleTimer(false)
        if (this.playing) {
          // audio.pause()
          // this.playerService.stop()
          // this.played && this.toolbelt.toggleTimer(false)
          console.log('暂停')
        }
      })
      audio.addEventListener(
        'canplay',
        () => {
          // this.duration = audio.duration
          console.log('canplay')
          // this.play(true)
        },
        { once: true }
      )
      audio.addEventListener(
        'canplaythrough',
        () => {
          console.log('canplaythrough')
          if (this.playing) {
            console.log('go on')
          } else {
            console.log('not')
          }
        },
        false
      )
      audio.addEventListener('ended', () => {
        this.$emit('presenter-change')
        this.playerService.reset()
      })
      audio.load()
      return audio
    },
    createPlayerService(actions, speed) {
      // const baselineTime = actions[0].timestamp
      // const doAction = this.createDoAction()
      // actions.forEach(action => {
      //   action.delay = action.timestamp - baselineTime
      //   action.doAction = doAction
      // })
      const timer = new Timer([], speed)
      timer.addActions(actions)
      return timer
    },
    createAction(actions, baselineTime) {
      const vm = this
      const doAction = function () {
        console.log('delay', this.delay)
        vm.tim.startMessageOnce(this.message)
      }
      const blt = baselineTime || actions[0].timestamp
      actions.forEach((action) => {
        action.delay = action.timestamp - blt
        action.doAction = doAction
      })
      return actions
    },
    play(isKeep) {
      if (this.loading) return
      const audio = this.$refs.audio
      const { isForPresentation, playerService, playing } = this
      if (audio.duration) {
        playerService.stop()
      }
      if (playing) {
        audio.pause()
        this.toggleToolbeltTimer(false)
        return
      }
      let t = audio.currentTime * 1000
      if (isKeep) {
        if (!isForPresentation) {
          this.$emit('presenter-change', true)
          this.$emit('reset', () => {
            this.$nextTick(() => {
              playerService.play()
              audio.play()
            })
          })
          return
        }
        playerService.play(t)
      } else {
        playerService.reset()
        playerService.start(t)
      }
      audio.play()
      this.toggleToolbeltTimer(true)
    },
    seek(precent) {
      const { duration, playing, audio, playerService } = this
      const t = Math.abs((duration * precent) / 100)
      audio.currentTime = t
      if (!playing) {
        this.play()
        return
      }
      playerService.reset()
      playerService.start(t * 1000)
    },
    update(timeOffset) {
      const { playerService } = this
      if (!playerService) return
      playerService.update(timeOffset)
    },
    touchstart() {
      this.isTouchMove = true
    },
    touchend() {
      this.isTouchMove = false
    },
    // 控制同屏控制条计时器
    toggleToolbeltTimer(isOn) {
      const toolbelt = this.$parent.$refs.presentationToolbelt
      if (!toolbelt || !toolbelt.toggleTimer || !this.played) return
      toolbelt.toggleTimer(isOn)
    },
    formatTime(time) {
      const t = new Date(parseInt(time * 1000))
      const formatter = time >= 60 * 60 ? '{h}:{i}:{s}' : '{i}:{s}'
      return parseTime(t, formatter)
    },
    currentPrecent(currentTime) {
      const diff = Math.floor((currentTime / this.duration) * 10000) / 100
      this.precent = diff
    },
    format(t) {
      var secNum = parseInt(t)
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - hours * 3600) / 60)
      var seconds = secNum - hours * 3600 - minutes * 60
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return hours + ':' + minutes + ':' + seconds
    },
  },
}
</script>
<template>
  <div class="replay-toolbelt" data-zindex="2000" @touchmove.prevent>
    <!-- <div class="controls" :class="loading ? 'loading' : ''">
      <div
        class="video-btn"
        :class="playing ? 'play' : 'pause'"
        @click="play(true)"
      ></div>
      <svg viewBox="0 0 50 50" class="load">
        <circle cx="25" cy="25" r="20" fill="none" class="path"></circle>
      </svg>
      <div class="video-time">
        {{ currentTimeStamp }}/{{ durationTimeStamp }}
      </div>
      <slider
        class="video-slider"
        v-model="precent"
        :step="0.01"
        :disabled="disabled || loading"
        @change="seek"
        @movestart="touchstart"
        @moveend="touchend"
      />
    </div> -->
    <div
      class="simple-controls"
      :class="[loading ? 'loading' : '', nowPlaying ? 'now' : '']"
    >
      <div class="video-time">
        {{ excessTimeStamp }}
      </div>
      <div
        class="video-btn"
        :class="playing ? 'play' : 'pause'"
        @click="play(true)"
      />
      <svg viewBox="0 0 50 50" class="load">
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          class="path"
        />
      </svg>
    </div>
    <audio ref="audio" :src="audioSrc" preload />
  </div>
</template>
<style lang="postcss" scoped>
@import 'variable';
.replay-toolbelt {
  z-index: 2000;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  .controls {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    background-color: rgba(0, 0, 0, 0.5);
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
    &.loading {
      .video-btn {
        display: none;
      }
      .load {
        display: block;
      }
    }
    .video-btn {
      height: 30px;
      width: 30px;
      &.play {
        background-image: url(https://media.winbaoxian.com/autoUpload/activity/pause_7938f2e1d732bab.png);
        background-size: 100%;
      }
      &.pause {
        background-image: url(https://media.winbaoxian.com/autoUpload/activity/play_e1c55b18b9879c6.png);
        background-size: 100%;
      }
    }
    .load {
      display: none;
      width: 30px;
      height: 30px;
      animation: loading-rotate 1.5s infinite ease-in-out;
      .path {
        stroke: #fff;
        stroke-width: 4;
        stroke-dasharray: 95, 126;
        stroke-dashoffset: 0;
        animation: loading-dash 1.5s ease-in-out infinite;
      }
    }
    .video-time {
      margin: 0 10px;
      text-align: right;
      font-size: 14px;
      color: #fff;
    }
    .video-slider {
      flex: 1;
    }
  }
  .simple-controls {
    box-sizing: border-box;
    position: absolute;
    left: 15px;
    right: 15px;
    bottom: 40px;
    display: flex;
    height: 58px;
    padding: 9px 15px;
    border-radius: 8px;
    align-items: center;
    justify-content: flex-end;
    background-color: rgba(0, 0, 0, 0.8);
    &.now {
      background: none;
    }
    &.loading {
      .video-btn {
        display: none;
      }
      .load {
        display: block;
      }
    }
    .video-btn {
      height: 30px;
      width: 30px;
      &.play {
        background-image: url(https://media.winbaoxian.com/autoUpload/activity/pause_7938f2e1d732bab.png);
        background-size: 100%;
      }
      &.pause {
        background-image: url(https://media.winbaoxian.com/autoUpload/activity/play_e1c55b18b9879c6.png);
        background-size: 100%;
      }
    }
    .load {
      display: none;
      width: 30px;
      height: 30px;
      animation: loading-rotate 1.5s infinite ease-in-out;
      .path {
        stroke: #fff;
        stroke-width: 4;
        stroke-dasharray: 95, 126;
        stroke-dashoffset: 0;
        animation: loading-dash 1.5s ease-in-out infinite;
      }
    }
    .video-time {
      margin: 0 10px;
      text-align: right;
      font-size: 14px;
      color: #fff;
    }
  }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 126;
    stroke-dashoffset: 0;
  }
  40% {
    stroke-dasharray: 95, 126;
    stroke-dashoffset: -31px;
  }
  to {
    stroke-dasharray: 1, 126;
    stroke-dashoffset: -126px;
  }
}
@keyframes loading-rotate {
  to {
    transform: rotate(1turn);
  }
}
</style>
<style>
.replay-error {
  z-index: 2001 !important;
}
</style>
